import { Stack } from '@mui/material';
import { FC } from 'react';
import { DispositionCard } from '../../../shared/components/DispositionCard';
import { FormsCard } from '../../../shared/components/FormsCard';
import { PatientEducationCard } from '../../../shared/components/plan-tab/PatientEducationCard';
import { PatientInstructionsCard } from '../../../shared/components/plan-tab/PatientInstructionsCard';
import { SchoolWorkExcuseCard } from '../../../shared/components/SchoolWorkExcuseCard';
import { useAppointmentData } from '../../../shared/stores/appointment/appointment.store';
import { useInPersonNavigationContext } from '../../context/InPersonNavigationContext';

export const PlanBody: FC = () => {
  const { location } = useAppointmentData();
  const { interactionMode } = useInPersonNavigationContext();
  const locationName = location?.name;
  const isFollowUp = interactionMode === 'follow-up';

  return (
    <Stack spacing={1}>
      {!isFollowUp && <PatientInstructionsCard />}
      {!isFollowUp && <DispositionCard />}
      {!isFollowUp && <PatientEducationCard />}
      <SchoolWorkExcuseCard locationName={locationName} />
      {!isFollowUp && <FormsCard />}
    </Stack>
  );
};
